const PATH = 'fe.pages.trainings.view';

const messages = {
  loadingTitle: {
    key: `${PATH}.loading_title`,
    defaultValue: 'Loading Training…'
  },
  unableToLoadTitle: {
    key: `${PATH}.unable_to_load_title`,
    defaultValue: 'Unable to Load Training'
  }
};

export default messages;
